/* eslint-disable unicorn/filename-case */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */


/* eslint-disable padding-line-between-statements */
/* eslint-disable consistent-return */
import React, { useCallback, useMemo, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { readViewModelValue, appendMetadataWithIndex } from '@xengage/gw-jutro-adapters-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { Button, InputField, DateField, Icon } from '@jutro/legacy/components';
import ViolationComponent from '../ViolationComponent/ViolationComponent'
import metadata from './RVDriverComponent.metadata.json5';
import styles from './RVDriverComponent.module.scss';
import OccupationSearchComponent from '../OccupationSearch/OccupationSearchComponent';
import { Link } from '@jutro/router';
import classNames from 'classnames';

function RVDriverComponent(props) {
    const {
        data: driverVM,
        readOnlyFields,
        labelPosition,
        phoneWide,
        path,
        id,
        index,
        onValidate,
        submissionVM,
        updateWizardData,
        isFromNewSubmission,
        onValueChange,
        showAccountHolderToggle,
        addOrRemoveAccHolderinExistingDriver,
        setIsValidFlag
    } = props;

    const { isComponentValid, onValidate: setComponentValidation, registerComponentValidation } = useValidation(id);
    const viewModelService = useContext(ViewModelServiceContext);												
    const formattedMetadata = useMemo(() => appendMetadataWithIndex(metadata.pageContent, index), [index]);
    const isViolationsComponentValid = useCallback(() => {
        const violationsVM = driverVM.violations

        if (violationsVM) {
            return violationsVM.aspects.valid && violationsVM.aspects.subtreeValid;
        }

        return true;

    }, [driverVM.violations]);

    useEffect(() => {
        
        registerComponentValidation(isViolationsComponentValid)

        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [driverVM, id, onValidate, isComponentValid, registerComponentValidation, isViolationsComponentValid]);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [driverVM, id, onValidate, isComponentValid]);

    function setTotalMinorAndMajorPoints() {
    let totalMinor = 0;
    let totalMajor = 0;

    // Check if Off Road Vehicle is selected
    if (isOffRoad) {
        const violations = driverVM.violations?.value || [];
        const currentYear = new Date().getFullYear();

        violations.forEach(violation => {
            const violationYear = violation.dateOfViolation?.year;
            const yearsSinceViolation = violationYear !== undefined ? currentYear - violationYear : null;

            if (
                violation.typeOfViolation === "minor" &&
                yearsSinceViolation !== null &&
                yearsSinceViolation <= 3
            ) {
                totalMinor += 1;
            } else if (
                violation.typeOfViolation === "major" &&
                yearsSinceViolation !== null &&
                yearsSinceViolation <= 5
            ) {
                totalMajor += 1;
            }
        });

        // Set the totals on the driverVM
        if (driverVM.totNumOfMinVioInLasThrYea) {
            driverVM.totNumOfMinVioInLasThrYea.value = totalMinor;
        }
        if (driverVM.totNumOfMajVioInLasFivYea) {
            driverVM.totNumOfMajVioInLasFivYea.value = totalMajor;
        }
    }
}

    const calculateViolationPoints = () => {
       const totalPenality = driverVM.violations?.value?.reduce((acc, violation) => acc + (violation.numOfPenaltyPoints || 0), 0);
        if(driverVM.totalPenality){
            driverVM.totalPenality.value = totalPenality;
        }
        driverVM.movingViolationForAll.value = driverVM.violations.length;
        setTotalMinorAndMajorPoints();

    };

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${path}.${changedPath}`;
            if(!!isFromNewSubmission && changedPath === 'sameAsAccountHolder'){
                setSameAsAccountHolder(value)
                const newSubmissionVMClone = viewModelService.clone(submissionVM);
                updateWizardData(newSubmissionVMClone);
                addOrRemoveAccHolderinExistingDriver()
             }
            if (onValueChange) {
                onValueChange(value, fullPath);
            }
            if(changedPath.includes('violations')){
                calculateViolationPoints()
            }
            
        },
        [addOrRemoveAccHolderinExistingDriver, isFromNewSubmission, onValueChange, path, submissionVM, updateWizardData, viewModelService]
    );

    const isVacTrailer = driverVM.offering_Ext && driverVM.offering_Ext.value  === "VacTra";
    const isMotorCycle = driverVM.offering_Ext && driverVM.offering_Ext.value  === "MotCyc";
    const isOffRoad = driverVM.offering_Ext && driverVM.offering_Ext.value  === "OffRoaVeh";

    const setSameAsAccountHolder = (sameAsAccountHolder) => {
        if(sameAsAccountHolder){
            const accountHolder = _.clone(_.get(submissionVM, 'baseData.accountHolder.value'));
            if(accountHolder.subtype === "Person") {
                _.set(driverVM, 'person.value', accountHolder);
            }                
        } else {
            _.set(driverVM, 'person.value', {});
        }     
        _.set(driverVM, 'relationshipToPNI.value', undefined);
        _.set(driverVM, 'licenseState.value', undefined);
        _.set(driverVM, 'licenseStatus.value', undefined);
        _.set(driverVM, 'licenseNumber.value', undefined);
        _.set(driverVM, 'hasLicenseSuspended.value', undefined);
        _.set(driverVM, 'latestLicenceReinstateDate.value', undefined);
        _.set(driverVM, 'yearsOfExp.value', undefined);
        _.set(driverVM, 'hasSafetyCourseCompleted.value', undefined);
        _.set(driverVM, 'certificateDetails.value', []); 
        _.set(driverVM, 'sameAsAccountHolder', sameAsAccountHolder);
        
    }

    const generateNewCertificationRow = useCallback(
        (event) => {
            event.preventDefault();

            if (driverVM.certificateDetails.value === undefined) {
                driverVM.certificateDetails.value = [];
            }

            const { _xCenter, _dtoName } = driverVM.certificateDetails;
            const certificateRecordVM = viewModelService.create({},_xCenter, _dtoName);

            driverVM.certificateDetails.pushElement(certificateRecordVM);
            handleValueChange(driverVM.value, path);
        },
        [driverVM.certificateDetails, driverVM.value, handleValueChange, path, viewModelService]
    );

    const getCertificateTableCell =  useCallback(
        (item, index, props) => {
           let {path} = props;
           const value = item[path];
            if (props.path === 'courseName') {
                path  = `certificateDetails.children[${index}].${path}`;
                return (
                    <InputField
                        dataType="string"
                        id={index + path}
                        value={value}
                        path={path}
                        onValueChange={handleValueChange}
                    />
                );
            }
            if(props.path === 'completionDate') {
                path  = `certificateDetails.children[${index}].${path}`;
                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType={_.isString(value) ? 'string' : 'object'}
                        path={path}
                        format="short"
                        layout="full-width"
                        showOptional={false}
                        onValueChange={handleValueChange}
                    />
                );
            }
        },
        [ handleValueChange]
    );

    const handleAddViolation = useCallback(
        (violationRecordVM) => {
            driverVM.violations.pushElement(violationRecordVM);
           // handleValueChange(driverVM.value, path);
            _.set(submissionVM, path, driverVM.value);
            driverVM.movingViolationForAll.value = driverVM.violations.length;
           const newSubmissionVMClone = viewModelService.clone(submissionVM);
           updateWizardData(newSubmissionVMClone);
        },
        [driverVM, path,updateWizardData, submissionVM]
    );

    const removeCertificationRow = useCallback(
        (rowIndex) => {
            driverVM.certificateDetails.value.splice(rowIndex, 1);
            _.set(submissionVM, path, driverVM.value);
            updateWizardData(submissionVM);
        },
        [driverVM, path, submissionVM, updateWizardData]
    ); 

    const removeCertificateRow = useCallback(
        (item, index) => (
                <Link
                    onClick={() => removeCertificationRow(index, item)}
                    className={classNames(styles.deleteSection, styles.deleteRow)}
                >
                    <Icon icon="mi-delete" className={styles.deleteIcon} />
                </Link>
            ),
        [removeCertificationRow]
    );

    const handleCustomValidation = useCallback(() => {
        const drivers = _.get(submissionVM, 'lobData.recVehLine.exposures.prvdriExposures.value', []);

        drivers.forEach((driver) => {
            if(driver.yearsOfExp===0){
                setIsValidFlag(false)
            }
            else{
                setIsValidFlag(true)
            }
            
        });
    }, [submissionVM]);

    const handleAge = useCallback((index) => {
       let result=0 ;
        if(!_.isEmpty(_.get(submissionVM, `lobData.recVehLine.exposures.prvdriExposures.value.${index}.dateOfBirth`)) || !_.isUndefined(_.get(submissionVM, `lobData.recVehLine.exposures.prvdriExposures.value.${index}.dateOfBirth`))){
            result = new Date().getFullYear() - (_.get(submissionVM, `lobData.recVehLine.exposures.prvdriExposures.value.${index}.dateOfBirth.year`));
       }
       return result;
    }, [submissionVM]);

    const handleDateOfBirth = useCallback((val,index) => {
         _.set(submissionVM,`lobData.recVehLine.exposures.prvdriExposures.value.${index}.dateOfBirth`,val)
          updateWizardData(submissionVM);
          handleAge(index);
     }, [submissionVM]);

    const setSubmission = useCallback((submissionVM) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        updateWizardData(newSubmissionVM);
    });
    
    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true,
            labelPosition,
            phoneWide,
        },
        [`driverSameAsAccountHolder${index}`]:{
            visible: index === 0 && showAccountHolderToggle
        },
        [`driverFirstName${index}`]: { 
            readOnly: index === 0 ? (driverVM.sameAsAccountHolder.value) : _.includes(readOnlyFields, 'driverFirstName') 
        },
        [`driverLastName${index}`]: { 
            readOnly: index === 0 ? (driverVM.sameAsAccountHolder.value) : _.includes(readOnlyFields, 'driverLastName')
        },
        [`driverDateOfBirth${index}`]: { 
            readOnly: _.includes(readOnlyFields, 'driverDateOfBirth'),
         },
        [`driverGender${index}`]: {
            readOnly: _.includes(readOnlyFields, 'driverGender') 
        },
        [`driverMaritalStatus${index}`]: { 
            readOnly: _.includes(readOnlyFields, 'driverMaritalStatus') 
        },
        [`driverLicenseNumber${index}`]: {
            readOnly: _.includes(readOnlyFields, 'driverLicenseNumber'),
            visible: driverVM.offering_Ext && driverVM.offering_Ext.value  !== "VacTra"
        },
        [`driverLicenceState${index}`]: { 
            readOnly: _.includes(readOnlyFields, 'driverLicenceState') ,
            visible: driverVM.offering_Ext && driverVM.offering_Ext.value  !== "VacTra"
        },
        [`driverLicenceStatus${index}`]: {
            visible: driverVM.offering_Ext && driverVM.offering_Ext.value  !== "VacTra"
        },
        [`homeNumberField${index}`]: {
            showRequired: _.get(driverVM.person, 'primaryPhoneType').value?.code === 'home',
            required: _.get(driverVM.person, 'primaryPhoneType').value?.code === 'home'
        },
        [`workNumberField${index}`]: {
            showRequired: _.get(driverVM.person, 'primaryPhoneType').value?.code === 'work',
            required: _.get(driverVM.person, 'primaryPhoneType').value?.code === 'work'
        },
        [`mobileNumberField${index}`]: {
            showRequired: _.get(driverVM.person, 'primaryPhoneType').value?.code === 'mobile',
            required: _.get(driverVM.person, 'primaryPhoneType').value?.code === 'mobile'
        },
        [`hasDriverLicenseSuspended${index}`]: {
            visible: driverVM.offering_Ext && driverVM.offering_Ext.value  !== "VacTra"
        },
        [`driverLicenseReinstatementDate${index}`]: {
            visible: (isMotorCycle || isOffRoad) && driverVM.hasLicenseSuspended.value === true
        },
        [`yearsOfDriverExp${index}`]: {
            visible: driverVM.offering_Ext && driverVM.offering_Ext.value  === "MotCyc",
            onBlur:handleCustomValidation,
            minValue: 1
        },
        [`hasSafetyCourseCompletedToggle${index}`]: {
            visible: driverVM.offering_Ext && driverVM.offering_Ext.value  === "OffRoaVeh"
        },
        [`hasReceivedCertifiedTraining${index}`]: {
            visible: driverVM.offering_Ext && driverVM.offering_Ext.value  === "MotCyc"
        },
        [`rvdriverHistoryHeader${index}`]: {
            visible: driverVM.offering_Ext && driverVM.offering_Ext.value  !== "VacTra"
        },
        [`driverHistoryContainer${index}`]: {
            visible: driverVM.offering_Ext && driverVM.offering_Ext.value  !== "VacTra"
        },
        [`certificateTable${index}`]:{
            data: driverVM.certificateDetails ? driverVM.certificateDetails.value : [],
            visible: driverVM.certificateDetails && driverVM.certificateDetails.value && driverVM.certificateDetails.value.length > 0
        },
        [`certificationData${index}`]:{
             visible : driverVM.havReceivedCertifiedTraining && driverVM.havReceivedCertifiedTraining.value === true
        }, 
        [`clubMembershipToggle${index}`]:{
            visible : driverVM.offering_Ext && driverVM.offering_Ext.value  === "MotCyc"
        },
        [`originalOwner${index}`]:{
            visible : driverVM.offering_Ext && driverVM.offering_Ext.value  === "MotCyc"
        },
        [`prevOwnedMotorCycle${index}`]:{
            visible : driverVM.offering_Ext && driverVM.offering_Ext.value  === "MotCyc"
        },
        [`yearsOfMotorCycleOwner${index}`]:{
            visible : driverVM.offering_Ext && driverVM.offering_Ext.value  === "MotCyc"
        },
        [`operatorPercentage${index}`]:{
           visible : driverVM.offering_Ext && driverVM.offering_Ext.value  === "MotCyc"
        },
        [`nameAssociationOrClub${index}`]:{
            visible : driverVM.offering_Ext && driverVM.offering_Ext.value  === "OffRoaVeh"
        },
        [`hasInsCancelOrRef${index}`]:{
            visible : driverVM.offering_Ext && driverVM.offering_Ext.value  === "MotCyc"
        },
        [`driverViolationsForAll${index}`]:{
            visible : driverVM.offering_Ext && driverVM.offering_Ext.value  === "MotCyc"
        },
        [`driverPenalityForAll${index}`]:{
            visible : driverVM.offering_Ext && driverVM.offering_Ext.value  === "MotCyc"
        },
        [`driverMovingViolations${index}`]:{
            visible : isOffRoad
        },
        [`driverViolationContainer${index}`]:{
            visible : (isMotorCycle) || (isOffRoad && driverVM.movingViolations && driverVM.movingViolations.value === true)
        },
        [`driverMinorViolations${index}`]:{
            visible : driverVM.offering_Ext && driverVM.offering_Ext.value  === "OffRoaVeh"
        },
        [`driverMajorViolations${index}`]:{
            visible : driverVM.offering_Ext && driverVM.offering_Ext.value  === "OffRoaVeh"
        },
        [`rvViolationComponent${index}`]:{
            value: driverVM.violations || [],
            path:  `lobData.recVehLine.exposures.prvdriExposures.children.${index}.violations`,
            index,
            onValueChange : handleValueChange,
            onValidate,
            handleAddViolation
        },
        [`licenseDetailsTitle${index}`]:{
            visible: driverVM.offering_Ext && driverVM.offering_Ext.value  !== "VacTra"
        },
        [`reaForSusOrCan${index}`]:{
            visible: isOffRoad || isMotorCycle && (driverVM.hasLicenseSuspended.value === true)
        },
        [`ageField${index}`]:{
           value: !_.isEmpty(_.get(submissionVM, `lobData.recVehLine.exposures.prvdriExposures.value.${index}.dateOfBirth`)) ? handleAge(index) : 0
        },
        [`reasonForCancellation${index}`]: {
            visible: isMotorCycle && driverVM.hasInsuranceBeenCancelled_Ext.value === true
        },
        [`occupationSearchComponent${index}`]: {
            id: `${index}${path}`,
            updateWizardData,
            index,
            viewModelService,
            submissionVM,
            modelVM: driverVM,
            pathUpdated: path,
            setSubmission
        }
    }), [labelPosition, phoneWide, index, showAccountHolderToggle, driverVM.sameAsAccountHolder.value, driverVM.offering_Ext, driverVM.certificateDetails, driverVM.hasSafetyCourseCompleted, driverVM.violations, readOnlyFields, handleValueChange, onValidate, handleAddViolation, updateWizardData])


    const resolvers = {
        resolveCallbackMap: {
            generateNewCertificationTableRow: generateNewCertificationRow,
            removeCertificateTableRow: removeCertificateRow,
            getCertificateTableCell,
            onValidate
        },
        resolveComponentMap: {
            violationComponent: ViolationComponent,
            occupationSearchComponent: OccupationSearchComponent
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            formattedMetadata,
            driverVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [driverVM, formattedMetadata, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={formattedMetadata}
            model={driverVM}
            overrideProps={overrideProps}
            onValidationChange={setComponentValidation}
            onValueChange={handleValueChange}
            resolveValue={readValue}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={styles}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

RVDriverComponent.propTypes = {
    data: PropTypes.shape({}),
    phoneWide: PropTypes.shape({}),
    labelPosition: PropTypes.string,
    path: PropTypes.string,
    onValueChange: PropTypes.func.isRequired,
    readOnlyFields: PropTypes.arrayOf(PropTypes.string),
    onValidate: PropTypes.func.isRequired,
    showOptional: PropTypes.bool,
    index: PropTypes.string,
    id: PropTypes.string
};
RVDriverComponent.defaultProps = {
    data: {},
    phoneWide: {
        labelPosition: 'top'
    },
    labelPosition: 'left',
    path: undefined,
    readOnlyFields: [],
    showOptional: true,
    id: undefined,
    index: 0
};
export default RVDriverComponent;
